import { render, staticRenderFns } from "./TransferPopup.vue?vue&type=template&id=60a5f4a0&"
import script from "./TransferPopup.vue?vue&type=script&lang=js&"
export * from "./TransferPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports